import type { SceneNodeItem, SceneNodeStyle } from "../scene/SceneNodeItem";
import type { ItemStoreEvents } from "../itemStore.store";

const textDefaults: SceneNodeStyle = {
  textAlign: "left" as CanvasTextAlign,
  textColor: null,
  fontSizeRelative: 1,
  lineHeight: null,
};

export const sceneTextStoreHooks: Partial<ItemStoreEvents<SceneNodeItem<"text">>> = {
  async beforeCreate(item) {
    // Apply style defaults
    if (!("textAlign" in item)) {
      item.textAlign = textDefaults.textAlign;
    }
    if (!("textColor" in item)) {
      item.textColor = textDefaults.textColor;
    }
    if (!("fontSizeRelative" in item)) {
      item.fontSizeRelative = textDefaults.fontSizeRelative;
    }
    if (!("lineHeight" in item)) {
      item.lineHeight = textDefaults.lineHeight;
    }

    return item;
  },

  afterUpdate(_updatedText, updatedData) {
    // Update defaults if style properties were changed

    if (updatedData.textAlign && updatedData.textAlign != null) {
      textDefaults.textAlign = updatedData.textAlign;
    }
    if (updatedData.textColor && updatedData.textColor != null) {
      textDefaults.textColor = updatedData.textColor;
    }
    if (updatedData.fontSizeRelative && updatedData.fontSizeRelative != null) {
      textDefaults.fontSizeRelative = updatedData.fontSizeRelative;
    }
    if (updatedData.lineHeight && updatedData.lineHeight != null) {
      textDefaults.lineHeight = updatedData.lineHeight;
    }
  }
};
